import {APIStatus} from '@web/core/constants'

import {ReceivableRewardState} from './interfaces'
export const getInitialState = (): ReceivableRewardState => ({
    apiStatus: {
        reviewTarget: APIStatus.IDLE,
        confirmationTarget: APIStatus.IDLE,
    },
    rewardedItems: [],
    reviewableItem: null,
    rewardableItem: null,
    isFamilyPay: false,
})
